//
//
//
//
//
//
//
//

  import {mapMutations} from 'vuex'

  export default {
    data(){
      return {}
    },
    async beforeMount(){
    },
    mounted(){
    },
    components: {},
    computed: {},
    methods: {},
    watch: {}
  }




// WEBPACK FOOTER //
// ./src/components/cart/CartBtn.vue